import React from 'react';
import usePrivateStoreHeaders from '../../../hooks/usePrivateStoreHeader';

export default () => {
    usePrivateStoreHeaders();
    return null;
}